import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/histogram/pages/CalculatorPage";

export const Route = createFileRoute("/histogram")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/histogram",
      title: m.hist_meta_title(),
      description: m.hist_meta_description(),
      toolName: m.hist_tool_name(),
      faqs: [
        { q: m.hist_faq_q1(), a: m.hist_faq_a1() },
        { q: m.hist_faq_q2(), a: m.hist_faq_a2() },
        { q: m.hist_faq_q3(), a: m.hist_faq_a3() },
        { q: m.hist_faq_q4(), a: m.hist_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
